import { useEffect, useState } from "react";
import { apiRequest } from "src/async/apiUtils";
import { toast } from "react-toastify";
import Button from "src/components/Shared/Buttons/Button";
import SlideOver from "src/components/Shared/SlideOver";
import { formJson } from "src/helpers/planHelper";
import PlanDefaultForm from "./PlanDefaultForm";
import Tabs from "src/components/Shared/Tabs/Tabs";
import FeaturesForm from "./PlanFeaturesForm";
import { ClipboardDocumentListIcon, SparklesIcon } from "@heroicons/react/24/outline";
import { useSearchParams } from "react-router-dom";

const PlanManageModal = ({ title = "", isOpen, editItem = null, onCancel = () => {}, onSuccess = () => {}, ...props }) => {
  const [formData, setFormData] = useState(formJson());
  const [disabled, setDisabled] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const onManage = async () => {
    try {
      setDisabled(true);
      const url = formData?._id ? `/plans/:plan_id` : `/plans`;
      const method = formData?._id ? `PUT` : `POST`;
      const { data } = await apiRequest(method, url, {
        body: formData,
        params: { plan_id: formData?._id },
      });
      setDisabled(false);
      toast.success(data.message);
      onSuccess();
    } catch (error) {
      setDisabled(false);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    setFormData(editItem ? { ...editItem, features: editItem?.features?.length ? editItem?.features : formJson()?.features } : formJson());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editItem]);

  return (
    <>
      <SlideOver
        isOpen={isOpen}
        handleClose={() => {
          searchParams.delete("tab");
          setSearchParams(searchParams);
          onCancel();
        }}
        title={title}
        description="View, update, and modify plan details and information below."
        size="5xl"
        bodyClassName="!p-4"
        footerComponent={
          <div className="flex w-full justify-end gap-x-3 ">
            <Button
              version="gray"
              onClick={onCancel}
              disabled={disabled}>
              Cancel
            </Button>
            <Button
              version="primary"
              type="button"
              onClick={onManage}
              disabled={disabled}
              loading={disabled}>
              Save
            </Button>
          </div>
        }>
        <div className="relative min-h-[200px] overflow-visible transition-all duration-100 ease-out ">
          <Tabs
            altDesign
            tabs={[
              {
                name: "Details",
                icon: ClipboardDocumentListIcon,
                component: (
                  <PlanDefaultForm
                    formData={formData}
                    setFormData={setFormData}
                  />
                ),
              },
              {
                name: "Features",
                icon: SparklesIcon,
                component: (
                  <FeaturesForm
                    formData={formData}
                    setFormData={setFormData}
                  />
                ),
              },
            ]}
          />
        </div>
      </SlideOver>
    </>
  );
};

export default PlanManageModal;
